import NextLink from 'next/link';

import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';
import { useParentElementViewContext } from '@savvy/deprecated-shared/tracking/parent-element-view-context';
import { useTrackEvent } from '@savvy/deprecated-shared/tracking/use-track-event';

export type TrackedLinkProps = {
  readonly elementName: TrackedClickableElementName;
  readonly href: string;
  readonly children: React.ReactNode;
  readonly onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  readonly target?: '_blank';
  readonly rel?: 'noreferrer';
};

function TrackedLink({ elementName, onClick, ...props }: TrackedLinkProps) {
  const trackButtonClick = useTrackEvent('userInteraction');
  const parentElementViewContext = useParentElementViewContext();
  const parentElementName = parentElementViewContext?.parentElementName;
  const parentElementType = parentElementViewContext?.parentElementType;

  return (
    <NextLink
      {...props}
      onClick={(event) => {
        trackButtonClick({
          elementName,
          htmlElement: 'button',
          interactionType: 'button_click',
          parentElementName,
          parentElementType,
        });
        return onClick?.(event);
      }}
    />
  );
}

export default TrackedLink;
